import {
  Box,
  PinInput,
  PinInputField,
} from '@medsimples/design-system/src/chakra';
import { useEffect, useState } from 'react';

export interface OTPInputProps {
  value?: string;
  onChange?: (_value: string) => void;
  placeholder?: string;
  isInvalid?: boolean;
}

export function OTPInput(props: OTPInputProps) {
  const [isInvalid, setIsInvalid] = useState(props.isInvalid);

  useEffect(() => {
    setIsInvalid(props.isInvalid);
  }, [props.isInvalid]);

  return (
    <Box display='flex' justifyContent='center' columnGap='8px'>
      <PinInput
        isInvalid={isInvalid}
        onChange={props.onChange}
        value={props.value}
        otp={true}
        type='number'
        placeholder={props.placeholder}
        size='md'
      >
        <PinInputField height='14' />
        <PinInputField height='14' />
        <PinInputField height='14' />
        <PinInputField height='14' />
        <PinInputField height='14' />
        <PinInputField height='14' />
      </PinInput>
    </Box>
  );
}
